import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";
import CrossIcon from "../../../assets/icons/crossIcon";

interface ResolvedModalProps {
  resolvedDrawer: boolean;
  setResolvedDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  handleTicketResolvedAction?: () => void;
}
const ResolvedModal: React.FC<ResolvedModalProps> = ({
  resolvedDrawer,
  setResolvedDrawer,
  handleTicketResolvedAction,
}) => {
  return (
    <Modal
      className="hidden md:block"
      open={resolvedDrawer}
      onClose={() => setResolvedDrawer(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "relative",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "35%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius:"8px"
        }}
      >
        <Box className="flex flex-col gap-4 " sx={{  borderRadius:"8px"}}>
          <Typography className="!pt-4 !px-3 !text-xl !font-medium !flex !justify-center" sx={{color:"#3F3F3F"}}>
            Are you sure you want to resolve the ticket?
          </Typography>
         <Box className="flex gap-4 justify-center">
          <Button
            sx={{
              textTransform: "none",
              border: "1px solid rgba(0, 0, 0, 0.2)",
              color: "#318FE0",
              width:{md:"50%", lg:"35%"},
            }}
            onClick={() => setResolvedDrawer(false)}
          >
            Cancel
          </Button>
          <Button
            sx={{
              textTransform: "none",
              backgroundColor: "#318FE0",
              color: "#fff",
              width:{md:"50%", lg:"35%"},
            }}
            onClick={handleTicketResolvedAction}
          >
            Confirm
          </Button>
          </Box>
        </Box>
        <Typography
          className="absolute top-0 right-0 p-1 cursor-pointer"
          onClick={() => setResolvedDrawer(false)}
        >
          <CrossIcon />
        </Typography>
      </Box>
    </Modal>
  );
};

export default ResolvedModal;
